var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.667 5H6.333V3.667h1.334zm0 5.333H6.333v-4h1.334zM7 .333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 7 .333"
})));
export { SvgInfo as ReactComponent };
export default __webpack_public_path__ + "Info.22ed6afe.svg";